<template>
  <div class="dimed wrap" v-if="emoneyReadyYn == true">
    <div class="layer" :class="{'layer--bottom': currentUrl.indexOf('idle') >= 0}">
      <div class="layer__header fix-h">
        <div class="lyr-title">{{ $t('Modal.EMoneyReady.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.EMoneyReady.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.EMoneyReady.msg3') }}</div>
      </div>
      <div class="layer__body no-margin" @mouseup="$emit('emCheck')">
        <img src="@/assets/images/user/artwork_popup_emoney_3d_jp.gif" alt="" class="img-size" />
        <div class="balance">
          <span class="dt">{{ $t('Modal.EMoneyReady.msg4') }}</span>
          <span class="dd">0{{ currUnitText }}</span>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeEmoneyReady')">{{ $t('Modal.EMoneyReady.msg5') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'emoneyReady',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      currentUrl: window.location.pathname,
      currUnitText: this.$store.getters.getCurrUnitText,
    };
  },
  props: {
    emoneyReadyYn: Boolean,
    paymethod: String,
  },
  mounted() {},
  methods: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    emoneyReadyYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00052', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style scoped></style>
